const ConsentValue = {
  Allowed: 'granted',
  Denied: 'denied'
};

module.exports = { ConsentValue };